export function SkeletonGrid() {
  return (
    <div className="grid grid-cols-2 gap-1.5 min-[480px]:grid-cols-3 sm:gap-3 md:grid-cols-4 xl:grid-cols-5" aria-busy>
      {Array.from({ length: 15 }, (_, i) => (
        <div key={i} className="skeleton aspect-[10/13] rounded-xl sm:rounded-2xl" />
      ))}
    </div>
  )
}
